import type {AuthSession} from '../auth';
import type {InterfaceModel,InterfaceRoute} from '../model';
import {contentFor,navigationFor} from '../model';
import {OriginRail} from '../components/origin-rail';
import {Shell} from '../components/shell';
import {Status} from '../components/status';
import {PageHeader} from '../design-system/components';

export function EnterpriseSurface({model,route,session,onSignOut}:{model:InterfaceModel;route:InterfaceRoute;session:AuthSession;onSignOut:()=>void}){
  const bootstrap=session.bootstrap!,claims=session.claims!;
  const tenant=String(claims[bootstrap.tenantClaim]);
  const principal=String(claims[bootstrap.principalClaim]);
  const values:Record<string,string>={
    Client:model.distribution.clientIdentity,
    Brand:model.distribution.brandProfileIdentity,
    Design:model.distribution.designSystemIdentity,
    Tenant:tenant
  };
  return <Shell model={model} route={route} links={navigationFor(model,'enterprise')} scope={tenant} principal={principal} onSignOut={onSignOut}>
    <section className="tu-contract-main tu-enterprise-workspace" aria-label="Enterprise workspace">
      <PageHeader eyebrow={route.eyebrow} title={route.title} description={route.description} tools={<Status value="white label"/>}/>
      <div className="tu-enterprise-posture"><div><span className="tu-kicker">Semantic parity</span><strong>Selected distribution</strong></div><Status value="selected"/></div>
      <div className="tu-contract-grid"><div className="tu-doc-stack">
        <article className="tu-panel tu-enterprise-contract"><header><div><span>White-label boundary</span><h2>Different client expression. One admitted backend and API contract.</h2></div><Status value="same semantics"/></header><p>The client, brand, terminology, and route composition change through the selected distribution. Tenant identity, authorization, claim origin, API capability, and financial meaning do not fork.</p></article>
        <section className="tu-panel tu-coordinate-grid" aria-label="Selected distribution coordinates">{contentFor(model,'enterprise-structure').map(block=><article key={block.identity}><span className="tu-kicker">{block.title}</span><strong>{values[block.title||'']}</strong><p>{block.body}</p></article>)}</section>
      </div><OriginRail model={model} scope={tenant}/></div>
    </section>
  </Shell>;
}
